/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({ ...props }) => (
  <svg
    style={{
      stroke: 'none',
      strokeWidth: 1,
      fill: 'none',
      fillRule: 'evenodd',
      overflow: 'visible'
    }}
    {...props}
  />
);

export const LoaderIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_2045_17566)">
        <circle cx="64" cy="12" r="12" fill="white" fillOpacity="0.1" />
        <circle cx="64" cy="116" r="12" fill="white" fillOpacity="0.65" />
        <circle cx="12" cy="64" r="12" fill="white" fillOpacity="0.85" />
        <circle cx="116" cy="64" r="12" fill="white" fillOpacity="0.35" />
        <circle cx="104" cy="30" r="12" fill="white" fillOpacity="0.25" />
        <circle cx="104" cy="100" r="12" fill="white" fillOpacity="0.45" />
        <circle cx="24" cy="100" r="12" fill="white" fillOpacity="0.75" />
        <circle cx="24" cy="30" r="12" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_2045_17566">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

LoaderIcon.propTypes = {
  className: PropTypes.string
};

export const UserIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        d="M21.2373 20.7585C23.8242 20.2263 25.8033 17.9433 25.8033 15.1654C25.8033 12.0078 23.2535 9.45801 20.0959 9.45801C16.9382 9.45801 14.3884 12.0078 14.3884 15.1282C14.3884 17.8677 16.329 20.189 18.9544 20.7213C14.2358 21.292 10.583 25.2488 10.583 30.538H29.6072C29.6087 25.2488 25.9559 21.3291 21.2373 20.7585Z"
        fill="white"
      />
    </Icon>
  );
};

UserIcon.propTypes = {
  className: PropTypes.string
};

export const TickIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        d="M7.16699 21.3328L0.166992 14.3328L2.49979 12L7.16699 16.6672L23.4998 0.332764L25.8326 2.66712L7.16699 21.3328Z"
        fill="#F2F3F4"
      />
    </Icon>
  );
};

TickIcon.propTypes = {
  className: PropTypes.string
};

export const SearchIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7417 12.8115C20.5529 11.6152 18.9411 10.9436 17.2609 10.9436C15.5798 10.9436 13.968 11.6153 12.7792 12.8115C11.5912 14.0067 10.9227 15.6284 10.9227 17.3199C10.9227 19.0114 11.5912 20.6331 12.7792 21.8283C13.968 23.0246 15.5798 23.6962 17.2609 23.6962C18.9411 23.6962 20.5529 23.0245 21.7417 21.8283C22.9297 20.6331 23.5973 19.0114 23.5973 17.3199C23.5973 15.6284 22.9297 14.0067 21.7417 12.8115ZM9.92692 11.6302C11.6803 9.34253 14.389 8.00104 17.2609 8.0001L17.261 8.00002C18.4995 7.9972 19.7259 8.24721 20.8669 8.73304C23.9011 10.0396 26.0143 12.8705 26.4166 16.1659C26.7008 18.4948 26.1004 20.8062 24.7964 22.6699L32 29.9179L29.9307 32L22.7544 24.7795C20.1329 26.7438 16.6741 27.174 13.6539 25.9063C11.0098 24.7799 9.0334 22.4837 8.30394 19.6895C7.57447 16.8952 8.17454 13.9188 9.92692 11.6302Z"
        fill="white"
      />
    </Icon>
  );
};

SearchIcon.propTypes = {
  className: PropTypes.string
};

export const SettingsIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 44" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3513 6.39688C18.2962 6.39688 18.2423 6.41126 18.1884 6.42564L14.6409 7.37473C14.563 7.3951 14.4935 7.43105 14.43 7.48018C14.3665 7.52931 14.3078 7.58324 14.267 7.65274C14.2263 7.72224 14.2011 7.80373 14.1903 7.88282C14.1795 7.9619 14.1867 8.04459 14.2095 8.12248L15.0149 11.1327C14.1699 11.6024 13.3849 12.2028 12.6946 12.9158L9.99075 11.3531C9.92124 11.3136 9.84933 11.2872 9.77023 11.2764C9.69113 11.2657 9.60843 11.2729 9.53053 11.2956C9.45263 11.316 9.38311 11.3519 9.31959 11.4011C9.25607 11.4502 9.19615 11.5137 9.1566 11.5832L7.32527 14.7565C7.28452 14.826 7.25936 14.9074 7.24857 14.9865C7.23778 15.0656 7.23778 15.1483 7.25816 15.2262C7.27853 15.3041 7.31448 15.3736 7.36362 15.4371C7.41276 15.5006 7.47628 15.5497 7.5458 15.5905L10.2496 17.1531C9.97756 18.107 9.85171 19.0824 9.8661 20.0483L6.85546 20.8631C6.77756 20.8835 6.69846 20.9194 6.63494 20.9686C6.57142 21.0177 6.52108 21.0716 6.48153 21.1411C6.44198 21.2106 6.41561 21.2921 6.40482 21.3712C6.39404 21.4503 6.40123 21.533 6.424 21.6109L7.37323 25.1577C7.3936 25.2356 7.42956 25.3051 7.4787 25.3686C7.52784 25.4321 7.59136 25.4921 7.66087 25.5316C7.73038 25.5724 7.80229 25.5975 7.88139 25.6083C7.96049 25.6191 8.04319 25.6083 8.12109 25.5891L11.1317 24.7839C11.6015 25.6287 12.202 26.4052 12.9151 27.0942L11.3522 29.7976C11.3115 29.8671 11.2863 29.9486 11.2755 30.0277C11.2647 30.1068 11.2719 30.1895 11.2947 30.2674C11.3151 30.3453 11.351 30.4148 11.4002 30.4783C11.4493 30.5418 11.5032 30.5909 11.5728 30.6317L14.756 32.4723C14.8255 32.5118 14.907 32.5382 14.9861 32.549C15.0652 32.5598 15.1479 32.549 15.2258 32.5298C15.3037 32.5094 15.3732 32.4735 15.4367 32.4243C15.5002 32.3752 15.5602 32.3117 15.5997 32.2422L17.153 29.5484C18.1058 29.8204 19.0814 29.9474 20.0486 29.9318L20.854 32.942C20.8743 33.0199 20.9103 33.0894 20.9594 33.1529C21.0086 33.2164 21.0721 33.2764 21.1416 33.3159C21.2111 33.3555 21.2926 33.3818 21.3717 33.3926C21.4508 33.4034 21.5335 33.3926 21.6114 33.3734L25.1588 32.4243C25.2367 32.404 25.3062 32.368 25.3698 32.3189C25.4333 32.2698 25.4836 32.2062 25.5232 32.1367C25.5639 32.0672 25.5891 31.9965 25.5999 31.9163C25.6107 31.836 25.6107 31.7545 25.5903 31.6766L24.7753 28.6664C25.6238 28.1967 26.4029 27.5975 27.0956 26.8833L29.7994 28.4459C29.8689 28.4867 29.9504 28.5118 30.0295 28.5226C30.1086 28.5334 30.1913 28.5226 30.2692 28.5034C30.3471 28.4831 30.4167 28.4471 30.4802 28.398C30.5437 28.3489 30.6024 28.2854 30.6432 28.2159L32.4745 25.0426C32.5141 24.9731 32.5404 24.8916 32.5512 24.8125C32.562 24.7335 32.5548 24.6508 32.532 24.5729C32.5117 24.495 32.4757 24.4255 32.4266 24.362C32.3774 24.2985 32.3235 24.2397 32.254 24.199L29.5502 22.6364C29.821 21.6885 29.9397 20.7214 29.9241 19.7604L32.9443 18.936C33.021 18.9144 33.0918 18.8796 33.1553 18.8305C33.2188 18.7814 33.2787 18.7179 33.3183 18.6484C33.3578 18.5789 33.3842 18.507 33.395 18.4279C33.4058 18.3488 33.3986 18.2661 33.3758 18.1882L32.4266 14.6413C32.4062 14.5634 32.3703 14.4939 32.3211 14.4304C32.272 14.3669 32.2085 14.307 32.1389 14.2674C32.0694 14.2279 31.9879 14.2015 31.9088 14.1908C31.8297 14.18 31.747 14.1872 31.6691 14.2099L28.6585 15.0152C28.1887 14.1716 27.5978 13.3855 26.8847 12.6952L28.438 9.99183C28.4775 9.92233 28.5039 9.85043 28.5147 9.77134C28.5255 9.69225 28.5255 9.60957 28.5051 9.53168C28.4847 9.45378 28.4488 9.3747 28.3996 9.31119C28.3505 9.24767 28.287 9.19854 28.2175 9.1578L25.0437 7.32675C24.9742 7.28601 24.8927 7.26084 24.8136 7.25006C24.7345 7.23927 24.6518 7.23927 24.5739 7.25964C24.496 7.28001 24.4265 7.31596 24.363 7.36509C24.2995 7.41423 24.2396 7.47774 24.2 7.54724L22.6467 10.2507C21.6927 9.97863 20.7088 9.85161 19.7416 9.86719L18.9362 6.85701C18.9014 6.72879 18.8307 6.61255 18.7252 6.53106C18.6198 6.44958 18.4844 6.39808 18.3513 6.39688ZM19.9142 13.7017C20.9629 13.7017 22.0307 13.9665 23.0014 14.5261C25.9605 16.2361 26.971 20.0419 25.2642 23.0007C23.5575 25.9593 19.7571 26.9697 16.7979 25.2631C13.8388 23.5531 12.8154 19.7569 14.5255 16.7981C15.6725 14.8125 17.7665 13.6992 19.9142 13.7017Z"
        fill="white"
      />
    </Icon>
  );
};

SettingsIcon.propTypes = {
  className: PropTypes.string
};

export const BackIcon = ({ className }) => (
  <Icon
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      {' '}
      <path fill="none" d="M0 0h24v24H0z" />{' '}
      <path
        fill="#FFFFFF"
        d="M8 7v4L2 6l6-5v4h5a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H8z"
      />{' '}
    </g>
  </Icon>
);

BackIcon.propTypes = {
  className: PropTypes.string
};

export const LikeOutlineIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 26 26" className={className}>
      <path
        transform="translate(0, 4)"
        d="M16.4466 1.39774C15.3449 1.83171 14.2439 2.55747 13.1565 3.62112C10.4894 1.1028 7.88761 0.532524 5.64542 1.10055C3.27634 1.70071 1.70571 3.48375 1.18766 4.42706L1.18379 4.43415L1.18302 4.43557C0.312086 6.046 0.182 7.96416 0.492498 9.67162C0.801688 11.3719 1.58306 13.062 2.78598 14.227L13.1807 24.6217L23.5758 14.2266C24.7773 13.0618 25.558 11.372 25.8668 9.67183C26.177 7.96459 26.0468 6.0467 25.1761 4.43587L24.7509 3.64911H24.6267C24.3426 3.3091 23.988 2.95352 23.5786 2.61871C22.8319 2.00805 21.8252 1.40236 20.6066 1.09903C19.3679 0.790715 17.9488 0.806024 16.4466 1.39774ZM17.5461 4.189C18.4316 3.8402 19.2104 3.84305 19.8819 4.0102C20.5736 4.18236 21.1893 4.54018 21.6793 4.94096C22.1856 5.35505 22.4709 5.74277 22.542 5.87173C23.0025 6.73045 23.1375 7.91173 22.9151 9.13564C22.6915 10.3666 22.142 11.4411 21.4823 12.0779L21.4758 12.084L13.1807 20.3791L4.89176 12.09L4.8785 12.0772C4.21792 11.4405 3.66794 10.3659 3.44409 9.13488C3.22111 7.9087 3.357 6.72577 3.81919 5.86759C3.91859 5.68856 4.20771 5.30745 4.66314 4.92282C5.11501 4.5412 5.70134 4.18115 6.38215 4.00868C6.99541 3.85332 7.77283 3.82918 8.70527 4.1912C9.64501 4.55605 10.7688 5.3238 12.0456 6.79801L13.2075 8.13967L14.3367 6.77037C15.5527 5.29589 16.6451 4.54391 17.5461 4.189Z"
        fill="white"
      />
    </Icon>
  );
};

LikeOutlineIcon.propTypes = {
  className: PropTypes.string
};

export const LikeIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 24 24" className={className}>
      <path
        transform="translate(0, 4)"
        d="M22.8564 3.1491C22.1219 1.814 17.5173 -2.65676 12.1794 3.81602C6.57376 -2.65676 2.23562 1.814 1.5024 3.1491C0.167287 5.61784 0.968096 9.35537 2.8375 11.1572L12.1807 20.5004L21.5239 11.1572C23.3908 9.35537 24.1916 5.61912 22.8565 3.1491H22.8564Z"
        fill="white"
      />
    </Icon>
  );
};

LikeIcon.propTypes = {
  className: PropTypes.string
};

export const RadioButtonOffIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 26 26" className={className}>
      <path
        transform="translate(0, 4)"
        d="M13 0C5.83181 0 0 5.83152 0 13C0 20.1685 5.83152 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83152 20.1685 0 13 0ZM13 23.4009C7.26435 23.4009 2.59885 18.7345 2.59885 12.9997C2.59885 7.26406 7.26406 2.59856 13 2.59856C18.7359 2.59856 23.4012 7.26493 23.4012 12.9997C23.4012 18.7345 18.7359 23.4009 13 23.4009Z"
        fill="white"
        fillOpacity="0.5"
      />
    </Icon>
  );
};

RadioButtonOffIcon.propTypes = {
  className: PropTypes.string
};
export const RadioButtonOnIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 26 26" className={className}>
      <path
        transform="translate(0, 4)"
        d="M4 13C4 8.03718 8.03718 4 13 4C17.9628 4 22 8.03718 22 13C22 17.9628 17.9628 22 13 22C8.03718 22 4 17.9628 4 13Z"
        fill="white"
      />
      <path
        transform="translate(0, 4)"
        d="M0 13C0 5.83152 5.83181 0 13 0C20.1685 0 26 5.83152 26 13C26 20.1685 20.1685 26 13 26C5.83152 26 0 20.1685 0 13ZM2.59885 12.9997C2.59885 18.7345 7.26435 23.4009 13 23.4009C18.7359 23.4009 23.4012 18.7345 23.4012 12.9997C23.4012 7.26493 18.7359 2.59856 13 2.59856C7.26406 2.59856 2.59885 7.26406 2.59885 12.9997Z"
        fill="white"
      />
    </Icon>
  );
};

RadioButtonOnIcon.propTypes = {
  className: PropTypes.object
};

const arrowProps = {
  className: PropTypes.string,
  style: PropTypes.object
};

export const ArrowUpIcon = ({ style, className }) => {
  return (
    <Icon viewBox="0 0 22 13" className={className} style={style}>
      <path
        d="M0.496205 10.568L2.47962 12.5174L10.7627 4.0603L19.2199 12.3434L21.168 10.3247L10.6934 0.12744L0.496205 10.568Z"
        fill="white"
      />
    </Icon>
  );
};

ArrowUpIcon.propTypes = arrowProps;

export const ArrowDownIcon = ({ className, style }) => {
  return (
    <Icon viewBox="0 0 22 13" className={className} style={style}>
      <path
        d="M21.1679 2.07693L19.1844 0.127487L10.9013 8.58463L2.44418 0.301495L0.496094 2.32027L10.9707 12.5175L21.1679 2.07693Z"
        fill="white"
      />
    </Icon>
  );
};

ArrowDownIcon.propTypes = arrowProps;

export const ArrowRightIcon = ({ className, style }) => {
  return (
    <Icon
      test="test"
      viewBox="-15 -2 42 23"
      className={className}
      style={style}
    >
      <path
        d="M2.58665 0.986454L0.637206 2.96987L9.09435 11.253L0.811215 19.7101L2.82999 21.6582L13.0272 11.1836L2.58665 0.986454Z"
        fill="white"
      />
    </Icon>
  );
};

ArrowRightIcon.propTypes = arrowProps;

export const ArrowLeftIcon = ({ className, style }) => {
  return (
    <Icon viewBox="-15 -2 42 23" className={className} style={style}>
      <path
        d="M11.0777 21.6582L13.0271 19.6748L4.56996 11.3917L12.8531 2.93454L10.8343 0.98645L0.637099 11.461L11.0777 21.6582Z"
        fill="white"
      />
    </Icon>
  );
};

ArrowLeftIcon.propTypes = arrowProps;

export const DeleteIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 20 22" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 0H7L0 10L7 20H28V0ZM12.5918 4.6L11.6 5.59177L16.0082 10C14.548 11.474 13.074 12.9479 11.6 14.4082L12.5918 15.4C14.0658 13.9397 15.5397 12.4658 17 11.0054C18.474 12.4658 19.9479 13.9397 21.4082 15.4L22.4 14.4082C20.9397 12.948 19.4658 11.474 18.0054 10C19.4658 8.53977 20.9397 7.06577 22.4 5.59177L21.4082 4.6C20.4352 5.58217 19.4561 6.55823 18.475 7.53633C17.9837 8.02611 17.4918 8.51641 17 9.00823C16.027 8.02607 15.0479 7.05002 14.0668 6.07194C13.5754 5.58214 13.0836 5.09184 12.5918 4.6Z"
        fill="#F2F3F4"
      />
    </Icon>
  );
};

DeleteIcon.propTypes = {
  className: PropTypes.string
};

export const FavouriteAddIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 24 21" className={className}>
      <path
        d="M16.4466 1.3978C15.3449 1.83177 14.2439 2.55753 13.1565 3.62118C10.4894 1.10286 7.88761 0.532585 5.64542 1.10061C3.27634 1.70077 1.70571 3.48381 1.18766 4.42712L1.18379 4.43421L1.18302 4.43563C0.312086 6.04606 0.182 7.96422 0.492498 9.67168C0.801688 11.3719 1.58306 13.0621 2.78598 14.227L13.1807 24.6218L23.5758 14.2267C24.7773 13.0618 25.558 11.3721 25.8668 9.67189C26.177 7.96465 26.0468 6.04676 25.1761 4.43593L24.7509 3.64917H24.6267C24.3426 3.30917 23.988 2.95358 23.5786 2.61877C22.8319 2.00811 21.8252 1.40242 20.6066 1.09909C19.3679 0.790776 17.9488 0.806085 16.4466 1.3978ZM17.5461 4.18906C18.4316 3.84026 19.2104 3.84311 19.8819 4.01026C20.5736 4.18242 21.1893 4.54024 21.6793 4.94102C22.1856 5.35511 22.4709 5.74283 22.542 5.87179C23.0025 6.73051 23.1375 7.91179 22.9151 9.1357C22.6915 10.3666 22.142 11.4412 21.4823 12.078L21.4758 12.084L13.1807 20.3791L4.89176 12.09L4.8785 12.0773C4.21792 11.4406 3.66794 10.3659 3.44409 9.13494C3.22111 7.90876 3.357 6.72583 3.81919 5.86765C3.91859 5.68862 4.20771 5.30751 4.66314 4.92288C5.11501 4.54126 5.70134 4.18121 6.38215 4.00874C6.99541 3.85338 7.77283 3.82924 8.70527 4.19126C9.64501 4.55611 10.7688 5.32386 12.0456 6.79807L13.2075 8.13973L14.3367 6.77043C15.5527 5.29595 16.6451 4.54397 17.5461 4.18906Z"
        fill="white"
      />
    </Icon>
  );
};

FavouriteAddIcon.propTypes = {
  className: PropTypes.string
};

export const FavouriteRemoveIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 24 21" className={className}>
      <path
        d="M22.8564 3.1491C22.1219 1.814 17.5173 -2.65676 12.1794 3.81602C6.57376 -2.65676 2.23562 1.814 1.5024 3.1491C0.167287 5.61784 0.968096 9.35537 2.8375 11.1572L12.1807 20.5004L21.5239 11.1572C23.3908 9.35537 24.1916 5.61912 22.8565 3.1491H22.8564Z"
        fill="white"
      />
    </Icon>
  );
};

FavouriteRemoveIcon.propTypes = {
  className: PropTypes.string
};

export const DetailsPlayIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 24 21" className={className}>
      <path
        d="M1.44699 22.6782C1.36563 22.6782 1.28327 22.6583 1.20885 22.6186C1.04315 22.5303 0.938965 22.3577 0.938965 22.1702V1.18643C0.938965 0.998901 1.04216 0.826244 1.20885 0.737949C1.37456 0.649639 1.57598 0.660554 1.73176 0.76474L17.305 11.2567C17.4449 11.351 17.5293 11.5088 17.5293 11.6784C17.5293 11.8471 17.4449 12.0049 17.305 12.1002L1.731 22.5921C1.64567 22.6497 1.54645 22.6785 1.44722 22.6785L1.44699 22.6782Z"
        fill="white"
      />
    </Icon>
  );
};

DetailsPlayIcon.propTypes = {
  className: PropTypes.string
};

export const DetailsLoginIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 24 21" className={className}>
      <path
        d="M11.2373 11.7585C13.8242 11.2263 15.8033 8.94334 15.8033 6.16542C15.8033 3.00781 13.2535 0.458008 10.0959 0.458008C6.93824 0.458008 4.38844 3.00781 4.38844 6.12817C4.38844 8.86773 6.32896 11.189 8.95437 11.7213C4.23575 12.292 0.583008 16.2488 0.583008 21.538H19.6072C19.6087 16.2488 15.9559 12.3291 11.2373 11.7585V11.7585Z"
        fill="white"
      />
    </Icon>
  );
};

DetailsLoginIcon.propTypes = {
  className: PropTypes.string
};

export const DetailsSubscribeIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 24 21" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8312 0.440782C11.61 0.440782 12.39 0.440782 13.1688 0.440782C13.1688 3.91503 13.185 7.37306 13.1688 10.8311C16.6431 10.8311 20.1011 10.8473 23.5591 10.8311V13.1687C20.1009 13.1848 16.6268 13.1849 13.1849 13.1848C13.1688 16.643 13.1687 20.1171 13.1688 23.559C12.39 23.559 11.61 23.559 10.8312 23.559C10.8312 20.1169 10.8312 16.643 10.8151 13.1848C7.37303 13.1848 3.89905 13.1848 0.440888 13.1687V10.8311C3.89905 10.8472 7.37316 10.8473 10.8312 10.8311L10.8312 0.440782V0.440782Z"
        fill="white"
      />
    </Icon>
  );
};

DetailsSubscribeIcon.propTypes = {
  className: PropTypes.string
};

export const ClockIcon = ({ className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5675 12.6162V19.1646C20.5675 19.4223 20.7776 19.6324 21.0352 19.6324H26.6481V22.4388H21.0352C19.2263 22.4388 17.761 20.9735 17.761 19.1646V12.6162H20.5675Z"
      fill="#F2F3F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.85683 9.85732C12.5735 7.14038 16.2571 5.60923 20.0995 5.6001C23.9458 5.6001 27.6328 7.12756 30.3534 9.84633C33.0721 12.5672 34.5996 16.2541 34.5996 20.1002C34.5904 23.9423 33.0593 27.6259 30.3424 30.3429C27.6257 33.0598 23.9422 34.591 20.0997 34.6001C16.2535 34.6001 12.5664 33.0726 9.84584 30.3539C7.12708 27.633 5.59961 23.9461 5.59961 20.1C5.60878 16.2579 7.13989 12.5743 9.85683 9.85732ZM11.8316 28.3679C14.0244 30.5623 16.9989 31.7938 20.0995 31.7938C23.1983 31.7846 26.1673 30.5492 28.358 28.3587C30.5487 26.1683 31.7839 23.1991 31.793 20.1003C31.793 16.9996 30.5615 14.025 28.3672 11.8324C26.1744 9.63804 23.1999 8.40656 20.0993 8.40656C17.0005 8.41573 14.0315 9.65114 11.8408 11.8416C9.65009 14.032 8.41493 17.0013 8.40579 20.1001C8.40579 23.2008 9.63727 26.1754 11.8316 28.3679Z"
      fill="#F2F3F4"
    />
  </Icon>
);

ClockIcon.propTypes = {
  className: PropTypes.string
};

export const UppercaseIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 20 22" className={className}>
      <path
        d="M15.28 21.6458H4.72V11.0625H0L10 0L19.56 11.0625H15.28V21.6458Z"
        fill="#F2F3F4"
      />
    </Icon>
  );
};

UppercaseIcon.propTypes = {
  className: PropTypes.string
};

export const EmailIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 20 22" className={className}>
      <path
        d="M0.200195 0.399902V1.37448L11.2071 8.87621L22.214 1.37448V0.399902H0.200195ZM0.200195 3.27454V15.5999H22.214V3.27454L11.6495 10.4814C11.3823 10.6626 11.0322 10.6626 10.765 10.4814L0.200195 3.27454Z"
        fill="#F2F3F4"
      />
    </Icon>
  );
};

EmailIcon.propTypes = {
  className: PropTypes.string
};

export const PasswordIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1884 14.3987L15.1959 17.2788H12.4697V14.3987C12.4697 10.8652 15.3338 8 18.8684 8C22.4018 8 25.268 10.866 25.267 14.3987V17.2788H22.5473V14.3987C22.5473 13.417 22.1647 12.4926 21.47 11.797C20.7753 11.1022 19.8509 10.7188 18.8683 10.7188C17.8848 10.7188 16.9613 11.1022 16.2666 11.797C15.571 12.4926 15.1884 13.4171 15.1884 14.3987ZM9.67041 32V19.1182H28.0667V32H9.67041ZM19.7883 28.7176V26.3082H19.7882C20.4108 25.9772 20.8364 25.3219 20.8364 24.5662C20.8364 23.4815 19.9551 22.5993 18.8685 22.5993C17.7819 22.5993 16.8997 23.4806 16.8997 24.5662C16.8997 25.3219 17.3253 25.9772 17.9488 26.3082V28.7176H19.7883Z"
        fill="#F2F3F4"
      />
    </Icon>
  );
};

PasswordIcon.propTypes = {
  className: PropTypes.string
};

/** Player Icons */

const PlayerIconPropTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  fill: PropTypes.string.isRequired,
  className: PropTypes.string
};

export const LanguageIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3513 6.39697C18.2962 6.39697 18.2423 6.41135 18.1884 6.42573L14.6409 7.37482C14.563 7.39519 14.4935 7.43114 14.43 7.48027C14.3665 7.5294 14.3078 7.58333 14.267 7.65283C14.2263 7.72233 14.2011 7.80382 14.1903 7.88291C14.1795 7.962 14.1867 8.04468 14.2095 8.12257L15.0149 11.1328C14.1699 11.6025 13.3849 12.2029 12.6946 12.9159L9.99075 11.3532C9.92124 11.3137 9.84933 11.2873 9.77023 11.2765C9.69113 11.2658 9.60843 11.2729 9.53053 11.2957C9.45263 11.3161 9.38311 11.352 9.31959 11.4012C9.25607 11.4503 9.19615 11.5138 9.1566 11.5833L7.32527 14.7565C7.28452 14.826 7.25936 14.9075 7.24857 14.9866C7.23778 15.0657 7.23778 15.1484 7.25816 15.2263C7.27853 15.3042 7.31448 15.3737 7.36362 15.4372C7.41276 15.5007 7.47628 15.5498 7.5458 15.5906L10.2496 17.1532C9.97756 18.1071 9.85171 19.0825 9.8661 20.0484L6.85546 20.8632C6.77756 20.8836 6.69846 20.9195 6.63494 20.9686C6.57142 21.0178 6.52108 21.0717 6.48153 21.1412C6.44198 21.2107 6.41561 21.2922 6.40482 21.3713C6.39404 21.4504 6.40123 21.5331 6.424 21.6109L7.37323 25.1578C7.3936 25.2357 7.42956 25.3052 7.4787 25.3687C7.52784 25.4322 7.59136 25.4922 7.66087 25.5317C7.73038 25.5724 7.80229 25.5976 7.88139 25.6084C7.96049 25.6192 8.04319 25.6084 8.12109 25.5892L11.1317 24.784C11.6015 25.6288 12.202 26.4053 12.9151 27.0943L11.3522 29.7977C11.3115 29.8672 11.2863 29.9487 11.2755 30.0278C11.2647 30.1069 11.2719 30.1896 11.2947 30.2675C11.3151 30.3453 11.351 30.4149 11.4002 30.4784C11.4493 30.5419 11.5032 30.591 11.5728 30.6317L14.756 32.4724C14.8255 32.5119 14.907 32.5383 14.9861 32.5491C15.0652 32.5598 15.1479 32.5491 15.2258 32.5299C15.3037 32.5095 15.3732 32.4736 15.4367 32.4244C15.5002 32.3753 15.5602 32.3118 15.5997 32.2423L17.153 29.5485C18.1058 29.8205 19.0814 29.9475 20.0486 29.9319L20.854 32.9421C20.8743 33.02 20.9103 33.0895 20.9594 33.153C21.0086 33.2165 21.0721 33.2765 21.1416 33.316C21.2111 33.3555 21.2926 33.3819 21.3717 33.3927C21.4508 33.4035 21.5335 33.3927 21.6114 33.3735L25.1588 32.4244C25.2367 32.4041 25.3062 32.3681 25.3698 32.319C25.4333 32.2699 25.4836 32.2063 25.5232 32.1368C25.5639 32.0673 25.5891 31.9966 25.5999 31.9163C25.6107 31.8361 25.6107 31.7546 25.5903 31.6767L24.7753 28.6665C25.6238 28.1968 26.4029 27.5976 27.0956 26.8834L29.7994 28.446C29.8689 28.4868 29.9504 28.5119 30.0295 28.5227C30.1086 28.5335 30.1913 28.5227 30.2692 28.5035C30.3471 28.4832 30.4167 28.4472 30.4802 28.3981C30.5437 28.349 30.6024 28.2854 30.6432 28.2159L32.4745 25.0427C32.5141 24.9732 32.5404 24.8917 32.5512 24.8126C32.562 24.7335 32.5548 24.6509 32.532 24.573C32.5117 24.4951 32.4757 24.4256 32.4266 24.3621C32.3774 24.2986 32.3235 24.2398 32.254 24.1991L29.5502 22.6365C29.821 21.6886 29.9397 20.7215 29.9241 19.7605L32.9443 18.936C33.021 18.9145 33.0918 18.8797 33.1553 18.8306C33.2188 18.7815 33.2787 18.718 33.3183 18.6484C33.3578 18.5789 33.3842 18.507 33.395 18.428C33.4058 18.3489 33.3986 18.2662 33.3758 18.1883L32.4266 14.6414C32.4062 14.5635 32.3703 14.494 32.3211 14.4305C32.272 14.367 32.2085 14.3071 32.1389 14.2675C32.0694 14.228 31.9879 14.2016 31.9088 14.1908C31.8297 14.1801 31.747 14.1872 31.6691 14.21L28.6585 15.0153C28.1887 14.1717 27.5978 13.3856 26.8847 12.6953L28.438 9.99192C28.4775 9.92242 28.5039 9.85052 28.5147 9.77143C28.5255 9.69234 28.5255 9.60966 28.5051 9.53177C28.4847 9.45388 28.4488 9.37479 28.3996 9.31128C28.3505 9.24777 28.287 9.19863 28.2175 9.15789L25.0437 7.32684C24.9742 7.2861 24.8927 7.26093 24.8136 7.25015C24.7345 7.23936 24.6518 7.23936 24.5739 7.25973C24.496 7.28011 24.4265 7.31605 24.363 7.36519C24.2995 7.41432 24.2396 7.47783 24.2 7.54733L22.6467 10.2507C21.6927 9.97873 20.7088 9.8517 19.7416 9.86728L18.9362 6.8571C18.9014 6.72888 18.8307 6.61264 18.7252 6.53115C18.6198 6.44967 18.4844 6.39817 18.3513 6.39697ZM19.9142 13.7018C20.9629 13.7018 22.0307 13.9666 23.0014 14.5262C25.9605 16.2362 26.971 20.042 25.2642 23.0008C23.5575 25.9594 19.7571 26.9698 16.7979 25.2632C13.8388 23.5532 12.8154 19.757 14.5255 16.7982C15.6725 14.8125 17.7665 13.6993 19.9142 13.7018Z"
      fill={fill}
    />
  </Icon>
);

export const AudioIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.8958 10.9948V8.04359H10.2983V27.641H20.304C21.5339 29.4214 23.7304 31.7066 27.0199 31.9536C27.0199 31.9536 25.739 29.9155 25.4409 27.641H29.8932V24.6899V24.6872V11.0003C29.8958 10.9976 29.8958 10.9976 29.8958 10.995L29.8958 10.9948ZM15.395 19.3059C14.5867 19.3059 13.9315 18.6506 13.9315 17.8424C13.9315 17.0341 14.5867 16.3789 15.395 16.3789C16.2033 16.3789 16.8585 17.0341 16.8585 17.8424C16.8612 18.6507 16.2059 19.3059 15.395 19.3059ZM20.0969 19.3059C19.2886 19.3059 18.6334 18.6506 18.6334 17.8424C18.6334 17.0341 19.2886 16.3789 20.0969 16.3789C20.9052 16.3789 21.5604 17.0341 21.5604 17.8424C21.5604 18.6507 20.9052 19.3059 20.0969 19.3059ZM24.7988 19.3059C23.9906 19.3059 23.3354 18.6506 23.3354 17.8424C23.3354 17.0341 23.9906 16.3789 24.7988 16.3789C25.6071 16.3789 26.2623 17.0341 26.2623 17.8424C26.2623 18.6507 25.6071 19.3059 24.7988 19.3059Z"
      fill={fill}
    />
  </Icon>
);

export const FFIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-1_4_239"
      maskUnits="userSpaceOnUse"
      x="2.11963"
      y="3.39999"
      width="36"
      height="33"
      fill="black"
    >
      <rect fill={fill} x="2.11963" y="3.39999" width="36" height="33" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7195 5.81818C26.0029 5.81818 32.0052 11.3094 32.8098 18.3783L30.5915 16.1609L29.5888 17.1636L32.5831 20.1565L32.5678 20.1717L33.5705 21.1744L33.5857 21.1591L33.601 21.1744L34.6037 20.1717L34.5884 20.1565L37.5813 17.1636L36.5786 16.1609L34.2478 18.4918C33.4887 10.5836 26.8271 4.39999 18.7197 4.39999C10.1039 4.39999 3.11973 11.3842 3.11973 20C3.11973 28.6158 10.1039 35.6 18.7197 35.6C24.7786 35.6 30.0318 32.1446 32.6147 27.098H30.9999C28.5471 31.333 23.9657 34.1818 18.7195 34.1818C10.8876 34.1818 4.53766 27.8319 4.53766 20C4.53766 12.1681 10.8876 5.81818 18.7195 5.81818ZM25.3092 23.4664C25.6049 22.7697 25.7528 21.8549 25.7528 20.7221V18.9101C25.7528 17.7723 25.6024 16.86 25.3016 16.1733C25.0059 15.4866 24.5874 14.9879 24.046 14.6771C23.5047 14.3663 22.8731 14.2109 22.1513 14.2109C21.4295 14.2109 20.7979 14.3663 20.2566 14.6771C19.7203 14.9879 19.3017 15.4866 19.001 16.1733C18.7052 16.86 18.5574 17.7723 18.5574 18.9101V20.7221C18.5574 21.8549 18.7077 22.7697 19.0085 23.4664C19.3092 24.1632 19.7303 24.6694 20.2716 24.9852C20.818 25.301 21.4496 25.4589 22.1663 25.4589C22.8931 25.4589 23.5247 25.301 24.061 24.9852C24.5974 24.6694 25.0134 24.1632 25.3092 23.4664ZM23.437 16.3688C23.7377 16.8049 23.8881 17.5593 23.8881 18.6319V20.9853C23.8881 22.063 23.7403 22.8299 23.4445 23.286C23.1538 23.7371 22.7277 23.9627 22.1663 23.9627C21.615 23.9627 21.1864 23.7371 20.8806 23.286C20.5749 22.8299 20.422 22.063 20.422 20.9853V18.6319C20.422 17.5593 20.5724 16.8049 20.8731 16.3688C21.1739 15.9327 21.5999 15.7147 22.1513 15.7147C22.7077 15.7147 23.1363 15.9327 23.437 16.3688ZM12.9484 25.3085H14.8206V14.3237H14.5875L10.2793 15.8951V17.459L12.9484 16.5643V25.3085Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7195 5.81818C26.0029 5.81818 32.0052 11.3094 32.8098 18.3783L30.5915 16.1609L29.5888 17.1636L32.5831 20.1565L32.5678 20.1717L33.5705 21.1744L33.5857 21.1591L33.601 21.1744L34.6037 20.1717L34.5884 20.1565L37.5813 17.1636L36.5786 16.1609L34.2478 18.4918C33.4887 10.5836 26.8271 4.39999 18.7197 4.39999C10.1039 4.39999 3.11973 11.3842 3.11973 20C3.11973 28.6158 10.1039 35.6 18.7197 35.6C24.7786 35.6 30.0318 32.1446 32.6147 27.098H30.9999C28.5471 31.333 23.9657 34.1818 18.7195 34.1818C10.8876 34.1818 4.53766 27.8319 4.53766 20C4.53766 12.1681 10.8876 5.81818 18.7195 5.81818ZM25.3092 23.4664C25.6049 22.7697 25.7528 21.8549 25.7528 20.7221V18.9101C25.7528 17.7723 25.6024 16.86 25.3016 16.1733C25.0059 15.4866 24.5874 14.9879 24.046 14.6771C23.5047 14.3663 22.8731 14.2109 22.1513 14.2109C21.4295 14.2109 20.7979 14.3663 20.2566 14.6771C19.7203 14.9879 19.3017 15.4866 19.001 16.1733C18.7052 16.86 18.5574 17.7723 18.5574 18.9101V20.7221C18.5574 21.8549 18.7077 22.7697 19.0085 23.4664C19.3092 24.1632 19.7303 24.6694 20.2716 24.9852C20.818 25.301 21.4496 25.4589 22.1663 25.4589C22.8931 25.4589 23.5247 25.301 24.061 24.9852C24.5974 24.6694 25.0134 24.1632 25.3092 23.4664ZM23.437 16.3688C23.7377 16.8049 23.8881 17.5593 23.8881 18.6319V20.9853C23.8881 22.063 23.7403 22.8299 23.4445 23.286C23.1538 23.7371 22.7277 23.9627 22.1663 23.9627C21.615 23.9627 21.1864 23.7371 20.8806 23.286C20.5749 22.8299 20.422 22.063 20.422 20.9853V18.6319C20.422 17.5593 20.5724 16.8049 20.8731 16.3688C21.1739 15.9327 21.5999 15.7147 22.1513 15.7147C22.7077 15.7147 23.1363 15.9327 23.437 16.3688ZM12.9484 25.3085H14.8206V14.3237H14.5875L10.2793 15.8951V17.459L12.9484 16.5643V25.3085Z"
      fill={fill}
    />
    <path
      d="M32.8098 18.3783L32.5977 18.5905L33.205 19.1975L33.1079 18.3444L32.8098 18.3783ZM30.5915 16.1609L30.8036 15.9487L30.5915 15.7367L30.3794 15.9488L30.5915 16.1609ZM29.5888 17.1636L29.3767 16.9515L29.1645 17.1636L29.3767 17.3758L29.5888 17.1636ZM32.5831 20.1565L32.7952 20.3686L33.0074 20.1564L32.7951 19.9443L32.5831 20.1565ZM32.5678 20.1717L32.3557 19.9596L32.1436 20.1717L32.3557 20.3838L32.5678 20.1717ZM33.5705 21.1744L33.3584 21.3865L33.5705 21.5987L33.7827 21.3865L33.5705 21.1744ZM33.5857 21.1591L33.7979 20.947L33.5857 20.7349L33.3736 20.947L33.5857 21.1591ZM33.601 21.1744L33.3888 21.3865L33.601 21.5987L33.8131 21.3865L33.601 21.1744ZM34.6037 20.1717L34.8158 20.3838L35.0279 20.1717L34.8158 19.9596L34.6037 20.1717ZM34.5884 20.1565L34.3763 19.9443L34.1642 20.1565L34.3763 20.3686L34.5884 20.1565ZM37.5813 17.1636L37.7934 17.3757L38.0056 17.1636L37.7934 16.9515L37.5813 17.1636ZM36.5786 16.1609L36.7907 15.9488L36.5786 15.7366L36.3665 15.9488L36.5786 16.1609ZM34.2478 18.4918L33.9491 18.5204L34.0099 19.1538L34.4599 18.7039L34.2478 18.4918ZM32.6147 27.098L32.8818 27.2347L33.1053 26.798H32.6147V27.098ZM30.9999 27.098V26.798H30.8269L30.7403 26.9476L30.9999 27.098ZM25.3092 23.4664L25.5853 23.5837L25.3092 23.4664ZM25.3016 16.1733L25.0261 16.292L25.0268 16.2937L25.3016 16.1733ZM24.046 14.6771L23.8967 14.9373L24.046 14.6771ZM20.2566 14.6771L20.1072 14.4169L20.1062 14.4175L20.2566 14.6771ZM19.001 16.1733L18.7262 16.053L18.7254 16.0547L19.001 16.1733ZM19.0085 23.4664L18.7331 23.5853L19.0085 23.4664ZM20.2716 24.9852L20.1205 25.2444L20.1215 25.245L20.2716 24.9852ZM23.4445 23.286L23.1928 23.1228L23.1923 23.1235L23.4445 23.286ZM20.8806 23.286L20.6314 23.453L20.6323 23.4543L20.8806 23.286ZM20.8731 16.3688L20.6262 16.1985V16.1985L20.8731 16.3688ZM14.8206 25.3085V25.6085H15.1206V25.3085H14.8206ZM12.9484 25.3085H12.6484V25.6085H12.9484V25.3085ZM14.8206 14.3237H15.1206V14.0237H14.8206V14.3237ZM14.5875 14.3237V14.0237H14.5345L14.4847 14.0419L14.5875 14.3237ZM10.2793 15.8951L10.1765 15.6133L9.9793 15.6852V15.8951H10.2793ZM10.2793 17.459H9.9793V17.876L10.3746 17.7435L10.2793 17.459ZM12.9484 16.5643H13.2484V16.1473L12.8531 16.2798L12.9484 16.5643ZM33.1079 18.3444C32.2862 11.1256 26.1572 5.51818 18.7195 5.51818V6.11818C25.8486 6.11818 31.7242 11.4932 32.5118 18.4122L33.1079 18.3444ZM30.3794 16.3731L32.5977 18.5905L33.0219 18.1661L30.8036 15.9487L30.3794 16.3731ZM29.8009 17.3757L30.8036 16.373L30.3794 15.9488L29.3767 16.9515L29.8009 17.3757ZM32.7951 19.9443L29.8009 16.9514L29.3767 17.3758L32.371 20.3686L32.7951 19.9443ZM32.7799 20.3838L32.7952 20.3686L32.3709 19.9443L32.3557 19.9596L32.7799 20.3838ZM33.7826 20.9622L32.78 19.9596L32.3557 20.3838L33.3584 21.3865L33.7826 20.9622ZM33.3736 20.947L33.3584 20.9623L33.7827 21.3865L33.7979 21.3713L33.3736 20.947ZM33.8131 20.9623L33.7979 20.947L33.3736 21.3713L33.3888 21.3865L33.8131 20.9623ZM34.3915 19.9596L33.3889 20.9622L33.8131 21.3865L34.8158 20.3838L34.3915 19.9596ZM34.3763 20.3686L34.3915 20.3838L34.8158 19.9596L34.8006 19.9443L34.3763 20.3686ZM37.3692 16.9515L34.3763 19.9443L34.8006 20.3686L37.7934 17.3757L37.3692 16.9515ZM36.3665 16.373L37.3692 17.3757L37.7934 16.9515L36.7907 15.9488L36.3665 16.373ZM34.4599 18.7039L36.7907 16.373L36.3665 15.9488L34.0356 18.2796L34.4599 18.7039ZM18.7197 4.69999C26.671 4.69999 33.2047 10.7647 33.9491 18.5204L34.5464 18.4631C33.7727 10.4026 26.9832 4.09999 18.7197 4.09999V4.69999ZM3.41973 20C3.41973 11.5499 10.2696 4.69999 18.7197 4.69999V4.09999C9.93823 4.09999 2.81973 11.2185 2.81973 20H3.41973ZM18.7197 35.3C10.2696 35.3 3.41973 28.4501 3.41973 20H2.81973C2.81973 28.7815 9.93823 35.9 18.7197 35.9V35.3ZM32.3477 26.9613C29.814 31.9116 24.6616 35.3 18.7197 35.3V35.9C24.8955 35.9 30.2495 32.3776 32.8818 27.2347L32.3477 26.9613ZM30.9999 27.398H32.6147V26.798H30.9999V27.398ZM18.7195 34.4818C24.077 34.4818 28.7553 31.5721 31.2595 27.2483L30.7403 26.9476C28.339 31.0938 23.8543 33.8818 18.7195 33.8818V34.4818ZM4.23766 20C4.23766 27.9976 10.7219 34.4818 18.7195 34.4818V33.8818C11.0533 33.8818 4.83766 27.6662 4.83766 20H4.23766ZM18.7195 5.51818C10.7219 5.51818 4.23766 12.0024 4.23766 20H4.83766C4.83766 12.3338 11.0533 6.11818 18.7195 6.11818V5.51818ZM25.4528 20.7221C25.4528 21.8328 25.3072 22.7033 25.033 23.3492L25.5853 23.5837C25.9026 22.8362 26.0528 21.8771 26.0528 20.7221H25.4528ZM25.4528 18.9101V20.7221H26.0528V18.9101H25.4528ZM25.0268 16.2937C25.3046 16.928 25.4528 17.7943 25.4528 18.9101H26.0528C26.0528 17.7502 25.9001 16.7921 25.5764 16.053L25.0268 16.2937ZM23.8967 14.9373C24.3713 15.2097 24.7508 15.6527 25.0261 16.292L25.5772 16.0547C25.261 15.3205 24.8034 14.766 24.1954 14.4169L23.8967 14.9373ZM22.1513 14.5109C22.829 14.5109 23.4074 14.6564 23.8967 14.9373L24.1954 14.4169C23.6019 14.0762 22.9172 13.9109 22.1513 13.9109V14.5109ZM20.406 14.9373C20.8952 14.6564 21.4736 14.5109 22.1513 14.5109V13.9109C21.3854 13.9109 20.7007 14.0762 20.1072 14.4169L20.406 14.9373ZM19.2758 16.2937C19.5564 15.6529 19.9366 15.2092 20.407 14.9367L20.1062 14.4175C19.5039 14.7665 19.047 15.3203 18.7262 16.053L19.2758 16.2937ZM18.8574 18.9101C18.8574 17.7939 19.0031 16.9269 19.2765 16.292L18.7254 16.0547C18.4074 16.7932 18.2574 17.7507 18.2574 18.9101H18.8574ZM18.8574 20.7221V18.9101H18.2574V20.7221H18.8574ZM19.2839 23.3475C19.0053 22.7022 18.8574 21.8324 18.8574 20.7221H18.2574C18.2574 21.8775 18.4102 22.8373 18.7331 23.5853L19.2839 23.3475ZM20.4228 24.7261C19.9476 24.4489 19.5648 23.9982 19.2839 23.3475L18.7331 23.5853C19.0537 24.3282 19.5129 24.89 20.1205 25.2443L20.4228 24.7261ZM22.1663 25.1589C21.495 25.1589 20.9166 25.0115 20.4218 24.7255L20.1215 25.245C20.7194 25.5905 21.4041 25.7589 22.1663 25.7589V25.1589ZM23.9088 24.7267C23.4259 25.0111 22.8487 25.1589 22.1663 25.1589V25.7589C22.9376 25.7589 23.6236 25.5909 24.2133 25.2437L23.9088 24.7267ZM25.033 23.3492C24.7568 23.9999 24.3787 24.4501 23.9088 24.7267L24.2133 25.2437C24.8161 24.8888 25.27 24.3265 25.5853 23.5837L25.033 23.3492ZM24.1881 18.6319C24.1881 17.5498 24.04 16.7147 23.684 16.1985L23.19 16.5391C23.4355 16.895 23.5881 17.5687 23.5881 18.6319H24.1881ZM24.1881 20.9853V18.6319H23.5881V20.9853H24.1881ZM23.6962 23.4492C24.0419 22.9161 24.1881 22.0738 24.1881 20.9853H23.5881C23.5881 22.0521 23.4386 22.7436 23.1928 23.1228L23.6962 23.4492ZM22.1663 24.2627C22.824 24.2627 23.3477 23.99 23.6967 23.4485L23.1923 23.1235C22.9598 23.4843 22.6314 23.6627 22.1663 23.6627V24.2627ZM20.6323 23.4543C20.9947 23.9889 21.5169 24.2627 22.1663 24.2627V23.6627C21.7131 23.6627 21.3781 23.4853 21.129 23.1177L20.6323 23.4543ZM20.122 20.9853C20.122 22.0747 20.2734 22.9189 20.6315 23.453L21.1298 23.1189C20.8764 22.7408 20.722 22.0512 20.722 20.9853H20.122ZM20.122 18.6319V20.9853H20.722V18.6319H20.122ZM20.6262 16.1985C20.2701 16.7147 20.122 17.5498 20.122 18.6319H20.722C20.722 17.5687 20.8746 16.895 21.1201 16.5391L20.6262 16.1985ZM22.1513 15.4147C21.5061 15.4147 20.9856 15.6773 20.6262 16.1985L21.1201 16.5391C21.3622 16.1881 21.6938 16.0147 22.1513 16.0147V15.4147ZM23.684 16.1985C23.324 15.6765 22.8004 15.4147 22.1513 15.4147V16.0147C22.6149 16.0147 22.9485 16.189 23.19 16.5391L23.684 16.1985ZM14.8206 25.0085H12.9484V25.6085H14.8206V25.0085ZM14.5206 14.3237V25.3085H15.1206V14.3237H14.5206ZM14.5875 14.6237H14.8206V14.0237H14.5875V14.6237ZM10.3821 16.177L14.6903 14.6056L14.4847 14.0419L10.1765 15.6133L10.3821 16.177ZM10.5793 17.459V15.8951H9.9793V17.459H10.5793ZM12.8531 16.2798L10.1839 17.1746L10.3746 17.7435L13.0438 16.8487L12.8531 16.2798ZM13.2484 25.3085V16.5643H12.6484V25.3085H13.2484Z"
      fill={fill}
      mask="url(#path-1-outside-1_4_239)"
    />
  </Icon>
);

export const NextIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5867 9.98644L13.6372 11.9699L22.0943 20.253L13.8112 28.7101L15.83 30.6582L26.0272 20.1836L15.5867 9.98644Z"
      fill={fill}
    />
  </Icon>
);

export const PlayIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.447 30.6782C12.3656 30.6782 12.2833 30.6584 12.2089 30.6187C12.0432 30.5304 11.939 30.3577 11.939 30.1702V9.18646C11.939 8.99893 12.0422 8.82627 12.2089 8.73798C12.3746 8.64967 12.576 8.66058 12.7318 8.76477L28.305 19.2568C28.4449 19.351 28.5293 19.5088 28.5293 19.6785C28.5293 19.8472 28.4449 20.0049 28.305 20.1002L12.731 30.5922C12.6457 30.6497 12.5464 30.6785 12.4472 30.6785L12.447 30.6782Z"
      fill={fill}
    />
  </Icon>
);

export const PauseIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7394 9H11.3374V30.85H16.7394V9ZM28.4491 9H23.0471V30.85H28.4491V9Z"
      fill={fill}
    />
  </Icon>
);

export const PrevIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0777 30.6583L26.0271 28.6749L17.57 20.3918L25.8531 11.9347L23.8343 9.98657L13.6371 20.4612L24.0777 30.6583Z"
      fill={fill}
    />
  </Icon>
);

export const RWIcon = ({ fill, className }) => (
  <Icon
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-1_4_240"
      maskUnits="userSpaceOnUse"
      x="1.12012"
      y="3.39999"
      width="36"
      height="33"
      fill="black"
    >
      <rect fill={fill} x="1.12012" y="3.39999" width="36" height="33" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9819 5.81818C13.6985 5.81818 7.69623 11.3094 6.89159 18.3783L9.10991 16.1609L10.1126 17.1636L7.11836 20.1565L7.13359 20.1717L6.1309 21.1744L6.11567 21.1591L6.10043 21.1744L5.09774 20.1717L5.11298 20.1565L2.12012 17.1636L3.12281 16.1609L5.45366 18.4918C6.21274 10.5836 12.8743 4.39999 20.9817 4.39999C29.5975 4.39999 36.5817 11.3842 36.5817 20C36.5817 28.6158 29.5975 35.6 20.9817 35.6C14.9229 35.6 9.66963 32.1446 7.0867 27.098H8.70155C11.1543 31.333 15.7357 34.1818 20.9819 34.1818C28.8138 34.1818 35.1638 27.8319 35.1638 20C35.1638 12.1681 28.8138 5.81818 20.9819 5.81818ZM28.3094 23.4664C28.6051 22.7697 28.753 21.8549 28.753 20.7221V18.9101C28.753 17.7723 28.6026 16.86 28.3019 16.1733C28.0061 15.4866 27.5876 14.9879 27.0463 14.6771C26.5049 14.3663 25.8733 14.2109 25.1515 14.2109C24.4298 14.2109 23.7982 14.3663 23.2568 14.6771C22.7205 14.9879 22.302 15.4866 22.0012 16.1733C21.7055 16.86 21.5576 17.7723 21.5576 18.9101V20.7221C21.5576 21.8549 21.708 22.7697 22.0087 23.4664C22.3095 24.1632 22.7305 24.6694 23.2719 24.9852C23.8182 25.301 24.4498 25.4589 25.1666 25.4589C25.8934 25.4589 26.525 25.301 27.0613 24.9852C27.5976 24.6694 28.0137 24.1632 28.3094 23.4664ZM26.4372 16.3688C26.738 16.8049 26.8884 17.5593 26.8884 18.6319V20.9853C26.8884 22.063 26.7405 22.8299 26.4448 23.286C26.154 23.7371 25.728 23.9627 25.1666 23.9627C24.6152 23.9627 24.1866 23.7371 23.8809 23.286C23.5751 22.8299 23.4222 22.063 23.4222 20.9853V18.6319C23.4222 17.5593 23.5726 16.8049 23.8734 16.3688C24.1741 15.9327 24.6002 15.7147 25.1515 15.7147C25.7079 15.7147 26.1365 15.9327 26.4372 16.3688ZM15.9487 25.3085H17.8208V14.3237H17.5877L13.2795 15.8951V17.459L15.9487 16.5643V25.3085Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9819 5.81818C13.6985 5.81818 7.69623 11.3094 6.89159 18.3783L9.10991 16.1609L10.1126 17.1636L7.11836 20.1565L7.13359 20.1717L6.1309 21.1744L6.11567 21.1591L6.10043 21.1744L5.09774 20.1717L5.11298 20.1565L2.12012 17.1636L3.12281 16.1609L5.45366 18.4918C6.21274 10.5836 12.8743 4.39999 20.9817 4.39999C29.5975 4.39999 36.5817 11.3842 36.5817 20C36.5817 28.6158 29.5975 35.6 20.9817 35.6C14.9229 35.6 9.66963 32.1446 7.0867 27.098H8.70155C11.1543 31.333 15.7357 34.1818 20.9819 34.1818C28.8138 34.1818 35.1638 27.8319 35.1638 20C35.1638 12.1681 28.8138 5.81818 20.9819 5.81818ZM28.3094 23.4664C28.6051 22.7697 28.753 21.8549 28.753 20.7221V18.9101C28.753 17.7723 28.6026 16.86 28.3019 16.1733C28.0061 15.4866 27.5876 14.9879 27.0463 14.6771C26.5049 14.3663 25.8733 14.2109 25.1515 14.2109C24.4298 14.2109 23.7982 14.3663 23.2568 14.6771C22.7205 14.9879 22.302 15.4866 22.0012 16.1733C21.7055 16.86 21.5576 17.7723 21.5576 18.9101V20.7221C21.5576 21.8549 21.708 22.7697 22.0087 23.4664C22.3095 24.1632 22.7305 24.6694 23.2719 24.9852C23.8182 25.301 24.4498 25.4589 25.1666 25.4589C25.8934 25.4589 26.525 25.301 27.0613 24.9852C27.5976 24.6694 28.0137 24.1632 28.3094 23.4664ZM26.4372 16.3688C26.738 16.8049 26.8884 17.5593 26.8884 18.6319V20.9853C26.8884 22.063 26.7405 22.8299 26.4448 23.286C26.154 23.7371 25.728 23.9627 25.1666 23.9627C24.6152 23.9627 24.1866 23.7371 23.8809 23.286C23.5751 22.8299 23.4222 22.063 23.4222 20.9853V18.6319C23.4222 17.5593 23.5726 16.8049 23.8734 16.3688C24.1741 15.9327 24.6002 15.7147 25.1515 15.7147C25.7079 15.7147 26.1365 15.9327 26.4372 16.3688ZM15.9487 25.3085H17.8208V14.3237H17.5877L13.2795 15.8951V17.459L15.9487 16.5643V25.3085Z"
      fill={fill}
    />
    <path
      d="M6.89159 18.3783L6.59351 18.3444L6.49641 19.1975L7.10368 18.5905L6.89159 18.3783ZM9.10991 16.1609L9.32204 15.9488L9.10995 15.7367L8.89782 15.9487L9.10991 16.1609ZM10.1126 17.1636L10.3247 17.3758L10.5369 17.1636L10.3247 16.9515L10.1126 17.1636ZM7.11836 20.1565L6.90627 19.9443L6.69405 20.1564L6.90622 20.3686L7.11836 20.1565ZM7.13359 20.1717L7.34572 20.3838L7.55785 20.1717L7.34573 19.9596L7.13359 20.1717ZM6.1309 21.1744L5.91876 21.3865L6.13089 21.5987L6.34303 21.3865L6.1309 21.1744ZM6.11567 21.1591L6.32781 20.947L6.11567 20.7349L5.90352 20.947L6.11567 21.1591ZM6.10043 21.1744L5.8883 21.3865L6.10044 21.5987L6.31258 21.3865L6.10043 21.1744ZM5.09774 20.1717L4.88561 19.9596L4.67348 20.1717L4.88561 20.3838L5.09774 20.1717ZM5.11298 20.1565L5.32511 20.3686L5.53724 20.1565L5.32511 19.9443L5.11298 20.1565ZM2.12012 17.1636L1.90799 16.9515L1.69585 17.1636L1.90799 17.3757L2.12012 17.1636ZM3.12281 16.1609L3.33494 15.9488L3.12281 15.7366L2.91068 15.9488L3.12281 16.1609ZM5.45366 18.4918L5.24153 18.7039L5.69149 19.1538L5.75229 18.5204L5.45366 18.4918ZM7.0867 27.098V26.798H6.59614L6.81964 27.2347L7.0867 27.098ZM8.70155 27.098L8.96115 26.9476L8.87448 26.798H8.70155V27.098ZM28.3094 23.4664L28.5855 23.5837L28.3094 23.4664ZM28.3019 16.1733L28.0263 16.292L28.0271 16.2937L28.3019 16.1733ZM27.0463 14.6771L26.8969 14.9373L27.0463 14.6771ZM23.2568 14.6771L23.1075 14.4169L23.1064 14.4175L23.2568 14.6771ZM22.0012 16.1733L21.7264 16.053L21.7257 16.0547L22.0012 16.1733ZM22.0087 23.4664L21.7333 23.5853L22.0087 23.4664ZM23.2719 24.9852L23.1207 25.2444L23.1218 25.245L23.2719 24.9852ZM26.4448 23.286L26.193 23.1228L26.1926 23.1235L26.4448 23.286ZM23.8809 23.286L23.6317 23.453L23.6326 23.4543L23.8809 23.286ZM23.8734 16.3688L23.6264 16.1985V16.1985L23.8734 16.3688ZM17.8208 25.3085V25.6085H18.1208V25.3085H17.8208ZM15.9487 25.3085H15.6487V25.6085H15.9487V25.3085ZM17.8208 14.3237H18.1208V14.0237H17.8208V14.3237ZM17.5877 14.3237V14.0237H17.5347L17.4849 14.0419L17.5877 14.3237ZM13.2795 15.8951L13.1767 15.6133L12.9795 15.6852V15.8951H13.2795ZM13.2795 17.459H12.9795V17.876L13.3749 17.7435L13.2795 17.459ZM15.9487 16.5643H16.2487V16.1473L15.8533 16.2798L15.9487 16.5643ZM7.18967 18.4122C7.97725 11.4932 13.8528 6.11818 20.9819 6.11818V5.51818C13.5442 5.51818 7.41522 11.1256 6.59351 18.3444L7.18967 18.4122ZM8.89782 15.9487L6.6795 18.1661L7.10368 18.5905L9.322 16.3731L8.89782 15.9487ZM10.3247 16.9515L9.32204 15.9488L8.89778 16.373L9.90047 17.3757L10.3247 16.9515ZM7.33044 20.3686L10.3247 17.3758L9.90052 16.9514L6.90627 19.9443L7.33044 20.3686ZM7.34573 19.9596L7.3305 19.9443L6.90622 20.3686L6.92145 20.3838L7.34573 19.9596ZM6.34303 21.3865L7.34572 20.3838L6.92146 19.9596L5.91877 20.9622L6.34303 21.3865ZM5.90352 21.3713L5.91876 21.3865L6.34305 20.9623L6.32781 20.947L5.90352 21.3713ZM6.31258 21.3865L6.32781 21.3713L5.90352 20.947L5.88829 20.9623L6.31258 21.3865ZM4.88561 20.3838L5.8883 21.3865L6.31256 20.9622L5.30988 19.9596L4.88561 20.3838ZM4.90084 19.9443L4.88561 19.9596L5.30988 20.3838L5.32511 20.3686L4.90084 19.9443ZM1.90799 17.3757L4.90085 20.3686L5.32511 19.9443L2.33225 16.9515L1.90799 17.3757ZM2.91068 15.9488L1.90799 16.9515L2.33225 17.3757L3.33494 16.373L2.91068 15.9488ZM5.66579 18.2796L3.33494 15.9488L2.91068 16.373L5.24153 18.7039L5.66579 18.2796ZM20.9817 4.09999C12.7182 4.09999 5.92874 10.4026 5.15503 18.4631L5.75229 18.5204C6.49674 10.7647 13.0304 4.69999 20.9817 4.69999V4.09999ZM36.8817 20C36.8817 11.2185 29.7632 4.09999 20.9817 4.09999V4.69999C29.4318 4.69999 36.2817 11.5499 36.2817 20H36.8817ZM20.9817 35.9C29.7632 35.9 36.8817 28.7815 36.8817 20H36.2817C36.2817 28.4501 29.4318 35.3 20.9817 35.3V35.9ZM6.81964 27.2347C9.45187 32.3776 14.8059 35.9 20.9817 35.9V35.3C15.0398 35.3 9.88739 31.9116 7.35375 26.9613L6.81964 27.2347ZM8.70155 26.798H7.0867V27.398H8.70155V26.798ZM20.9819 33.8818C15.8471 33.8818 11.3624 31.0938 8.96115 26.9476L8.44194 27.2483C10.9461 31.5721 15.6244 34.4818 20.9819 34.4818V33.8818ZM34.8638 20C34.8638 27.6662 28.6482 33.8818 20.9819 33.8818V34.4818C28.9795 34.4818 35.4638 27.9976 35.4638 20H34.8638ZM20.9819 6.11818C28.6482 6.11818 34.8638 12.3338 34.8638 20H35.4638C35.4638 12.0024 28.9795 5.51818 20.9819 5.51818V6.11818ZM28.453 20.7221C28.453 21.8328 28.3074 22.7033 28.0332 23.3492L28.5855 23.5837C28.9028 22.8362 29.053 21.8771 29.053 20.7221H28.453ZM28.453 18.9101V20.7221H29.053V18.9101H28.453ZM28.0271 16.2937C28.3049 16.928 28.453 17.7943 28.453 18.9101H29.053C29.053 17.7502 28.9004 16.7921 28.5767 16.053L28.0271 16.2937ZM26.8969 14.9373C27.3715 15.2097 27.751 15.6527 28.0263 16.292L28.5774 16.0547C28.2612 15.3205 27.8037 14.766 27.1956 14.4169L26.8969 14.9373ZM25.1515 14.5109C25.8292 14.5109 26.4077 14.6564 26.8969 14.9373L27.1956 14.4169C26.6021 14.0762 25.9175 13.9109 25.1515 13.9109V14.5109ZM23.4062 14.9373C23.8954 14.6564 24.4739 14.5109 25.1515 14.5109V13.9109C24.3856 13.9109 23.701 14.0762 23.1075 14.4169L23.4062 14.9373ZM22.276 16.2937C22.5566 15.6529 22.9369 15.2092 23.4072 14.9367L23.1064 14.4175C22.5041 14.7665 22.0473 15.3203 21.7264 16.053L22.276 16.2937ZM21.8576 18.9101C21.8576 17.7939 22.0033 16.9269 22.2768 16.292L21.7257 16.0547C21.4076 16.7932 21.2576 17.7507 21.2576 18.9101H21.8576ZM21.8576 20.7221V18.9101H21.2576V20.7221H21.8576ZM22.2842 23.3475C22.0056 22.7022 21.8576 21.8324 21.8576 20.7221H21.2576C21.2576 21.8775 21.4104 22.8373 21.7333 23.5853L22.2842 23.3475ZM23.423 24.7261C22.9479 24.4489 22.565 23.9982 22.2842 23.3475L21.7333 23.5853C22.054 24.3282 22.5132 24.89 23.1207 25.2443L23.423 24.7261ZM25.1666 25.1589C24.4952 25.1589 23.9168 25.0115 23.422 24.7255L23.1218 25.245C23.7197 25.5905 24.4044 25.7589 25.1666 25.7589V25.1589ZM26.9091 24.7267C26.4261 25.0111 25.8489 25.1589 25.1666 25.1589V25.7589C25.9378 25.7589 26.6238 25.5909 27.2135 25.2437L26.9091 24.7267ZM28.0332 23.3492C27.7571 23.9999 27.3789 24.4501 26.9091 24.7267L27.2135 25.2437C27.8163 24.8888 28.2703 24.3265 28.5855 23.5837L28.0332 23.3492ZM27.1884 18.6319C27.1884 17.5498 27.0402 16.7147 26.6842 16.1985L26.1903 16.5391C26.4357 16.895 26.5884 17.5687 26.5884 18.6319H27.1884ZM27.1884 20.9853V18.6319H26.5884V20.9853H27.1884ZM26.6965 23.4492C27.0421 22.9161 27.1884 22.0738 27.1884 20.9853H26.5884C26.5884 22.0521 26.4389 22.7436 26.193 23.1228L26.6965 23.4492ZM25.1666 24.2627C25.8243 24.2627 26.348 23.99 26.6969 23.4485L26.1926 23.1235C25.9601 23.4843 25.6317 23.6627 25.1666 23.6627V24.2627ZM23.6326 23.4543C23.9949 23.9889 24.5171 24.2627 25.1666 24.2627V23.6627C24.7133 23.6627 24.3784 23.4853 24.1292 23.1177L23.6326 23.4543ZM23.1222 20.9853C23.1222 22.0747 23.2736 22.9189 23.6317 23.453L24.1301 23.1189C23.8766 22.7408 23.7222 22.0512 23.7222 20.9853H23.1222ZM23.1222 18.6319V20.9853H23.7222V18.6319H23.1222ZM23.6264 16.1985C23.2704 16.7147 23.1222 17.5498 23.1222 18.6319H23.7222C23.7222 17.5687 23.8749 16.895 24.1203 16.5391L23.6264 16.1985ZM25.1515 15.4147C24.5063 15.4147 23.9858 15.6773 23.6264 16.1985L24.1203 16.5391C24.3624 16.1881 24.694 16.0147 25.1515 16.0147V15.4147ZM26.6842 16.1985C26.3242 15.6765 25.8007 15.4147 25.1515 15.4147V16.0147C25.6152 16.0147 25.9488 16.189 26.1903 16.5391L26.6842 16.1985ZM17.8208 25.0085H15.9487V25.6085H17.8208V25.0085ZM17.5208 14.3237V25.3085H18.1208V14.3237H17.5208ZM17.5877 14.6237H17.8208V14.0237H17.5877V14.6237ZM13.3823 16.177L17.6905 14.6056L17.4849 14.0419L13.1767 15.6133L13.3823 16.177ZM13.5795 17.459V15.8951H12.9795V17.459H13.5795ZM15.8533 16.2798L13.1842 17.1746L13.3749 17.7435L16.044 16.8487L15.8533 16.2798ZM16.2487 25.3085V16.5643H15.6487V25.3085H16.2487Z"
      fill={fill}
      mask="url(#path-1-outside-1_4_240)"
    />
  </Icon>
);

export const LeftArrowIcon = ({ fill, className }) => (
  <Icon
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.4804 5.6723L11.8411 4L4 12L11.8411 20L13.4804 18.3277L8.44747 13.1944L20 13.1944L20 10.8068L8.44628 10.8068L13.4804 5.6723Z"
      fill={fill}
    />
  </Icon>
);

export const RightArrowIcon = ({ fill, className }) => (
  <Icon
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.5196 18.3277L12.1589 20L20 12L12.1589 4L10.5196 5.6723L15.5525 10.8056H4L4 13.1932H15.5537L10.5196 18.3277Z"
      fill={fill}
    />
  </Icon>
);

export const EditIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        d="M15.0732 3.50624L18.3549 0.224609L23.2242 5.09399L19.9426 8.37562L15.0732 3.50624Z"
        fill="white"
      />
      <path
        d="M0.996875 17.5814L0.224609 23.2244L5.86759 22.4521L19.2548 9.06255L14.3866 4.19434L0.996875 17.5814Z"
        fill="white"
      />
    </Icon>
  );
};

EditIcon.propTypes = {
  className: PropTypes.string
};

export const LockIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        d="M14.1553 12.0194L14.1636 15.207H11.1534V12.0194C11.1534 8.10866 14.3158 4.9375 18.2186 4.9375C22.1201 4.9375 25.2848 8.10946 25.2837 12.0194V15.207H22.2807V12.0194C22.2807 10.9329 21.8583 9.90978 21.0912 9.13986C20.3241 8.37098 19.3034 7.94657 18.2185 7.94657C17.1325 7.94657 16.1129 8.37098 15.3458 9.13986C14.5777 9.90983 14.1553 10.933 14.1553 12.0194Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0625 31.5V17.2428H28.375V31.5H8.0625ZM19.2343 27.8672V25.2004C19.9217 24.8342 20.3916 24.1088 20.3916 23.2725C20.3916 22.072 19.4185 21.0955 18.2187 21.0955C17.0189 21.0955 16.0448 22.0709 16.0448 23.2725C16.0448 24.1088 16.5148 24.8342 17.2032 25.2004V27.8672H19.2343Z"
        fill="white"
      />
    </Icon>
  );
};

LockIcon.propTypes = {
  className: PropTypes.string
};

export const ProfileIcon = ({ className }) => {
  return (
    <Icon viewBox="0 0 40 40" className={className}>
      <path
        d="M13.2165 26.81C11.1315 25.34 9.57149 23.24 8.76149 20.825C7.95149 18.41 7.92149 15.8 8.70149 13.37C9.46649 10.94 10.9815 8.825 13.0365 7.31C15.0915 5.81 17.5815 5 20.1315 5C22.6815 5 25.1565 5.81 27.2265 7.31C29.2815 8.81 30.8115 10.94 31.5765 13.37C32.3415 15.8 32.3265 18.41 31.5165 20.825C30.7065 23.24 29.1465 25.34 27.0615 26.81L30.1815 33.95C30.2265 34.07 30.2565 34.19 30.2415 34.31C30.2415 34.43 30.1965 34.55 30.1215 34.655C30.0465 34.76 29.9565 34.85 29.8515 34.91C29.7465 34.97 29.6115 35 29.4915 35H10.7715C10.6515 35 10.5315 34.97 10.4115 34.91C10.3065 34.85 10.2015 34.76 10.1415 34.655C10.0815 34.55 10.0365 34.43 10.0215 34.31C10.0215 34.19 10.0215 34.055 10.0815 33.95L13.2015 26.81H13.2165ZM14.3115 18.455C14.6415 19.745 15.3915 20.9 16.4415 21.725C17.4915 22.55 18.7965 23 20.1315 23C21.4665 23 22.7715 22.55 23.8215 21.725C24.8715 20.9 25.6215 19.745 25.9515 18.455L23.0415 17.72C22.8765 18.365 22.5015 18.95 21.9765 19.355C21.4515 19.775 20.7915 19.985 20.1315 19.985C19.4715 19.985 18.8115 19.76 18.2865 19.355C17.7615 18.935 17.3865 18.365 17.2215 17.72L14.3115 18.455Z"
        fill="white"
      />
    </Icon>
  );
};

ProfileIcon.propTypes = {
  className: PropTypes.string
};

PlayIcon.propTypes = PlayerIconPropTypes;
PauseIcon.propTypes = PlayerIconPropTypes;
RWIcon.propTypes = PlayerIconPropTypes;
FFIcon.propTypes = PlayerIconPropTypes;
NextIcon.propTypes = PlayerIconPropTypes;
PrevIcon.propTypes = PlayerIconPropTypes;
AudioIcon.propTypes = PlayerIconPropTypes;
LanguageIcon.propTypes = PlayerIconPropTypes;
LeftArrowIcon.propTypes = PlayerIconPropTypes;
RightArrowIcon.propTypes = PlayerIconPropTypes;
EditIcon.propTypes = PlayerIconPropTypes;
LockIcon.propTypes = PlayerIconPropTypes;
ProfileIcon.propTypes = PlayerIconPropTypes;
/** End of Player Icons */

/* eslint-enable max-len */
